import React from 'react';
import Loadable from 'react-loadable';
import Loader from '../components/Loader';

export const asyncLoader = loader => Loadable({ loader, loading: () => <Loader /> });
